import { getRevenda } from "../config/auth";

export const urlTicketOnlineFromTicket = (ticket, from) => {
    const revenda = getRevenda()
    return `${revenda.siteTicket}?&t=${ticket.ticket}&e=${ticket.estacionamentoId}&ty=ticket&origin=${from ?? "adm"}`
}